import React, { useEffect, useState } from "react";
import { toolsAPI } from "../../utils/funcionesAPI";
import { getLocalidadesPorPartido, getPartidosPorProvincia, manejadorDeRespuesta } from "../../utils/Tools";
import SelectorDireccionesFactura from "./SelectorDireccionesFactura";

const DatosDeFacturacion = (props) => {
  const {
    formularioDefault,
    formulario,
    setFormulario,
    mostrarDatosDeFacturacion,
    setMostrarDatosDeFacturacion,
    formularioSeleccionado,
    setFormularioSeleccionado,
    pantallaOrigen,
    handleRepetirCampos,
    idProvincia,
    idPartido
  } = props;

  const [tiposDocumento, setTiposDocumento] = useState([]);

  const [provincias, setProvincias] = useState([]);
  const [partidos, setPartidos] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [deshabilitarTipoDocumento, setDeshabilitarTipoDocumento] =
    useState(true);
  const [deshabilitarFactura, setDeshabilitarFactura] = useState(true);

  const [mostrarInputsOcultos] = useState(2);

  /*
  const getLocalidadesPorProvincia = (codigoProvincia) => {
    const data = JSON.stringify({ accion: "localidades", codigoProvincia });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setLocalidades(respuesta.data);
    });
  };
  */

  useEffect(() => {
    let data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDocumento(respuesta.data);
    });

    data = JSON.stringify({ accion: "provincias" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) setProvincias(respuesta.data);
    });

    //getLocalidadesPorProvincia("ARC");
  }, []);

  useEffect(() => {
    getPartidosPorProvincia(formularioSeleccionado.provincia.codigo, setPartidos);
  }, [formularioSeleccionado.provincia.id]);

  const handelChangeFormulario = (e) => {
    //console.log(e.target.value);
    let formularioClone = Object.assign({}, formulario);
    formularioClone[e.target.name] = e.target.value;
    //FC: si es tipo de cliente valido los tipo de documento permitidos
    let deshabilitarTipoDocumentoClone = deshabilitarTipoDocumento;
    let deshabilitarFacturaClone = deshabilitarFactura;

    if (e.target.name === "numeroDocumento") {
      if (!/^\d*$/.test(e.target.value)) {
        return;
      }
    }

    if (e.target.name === "responsabilidad") {
      if (e.target.value === "CFI") {
        formularioClone.tipoDocumento = { sigla: "DNI" };
        deshabilitarTipoDocumentoClone = true;
        deshabilitarFacturaClone = false;
        formularioClone.factura = "FACB";
      } else if (e.target.value === "MON") {
        formularioClone.tipoDocumento = { sigla: "CUIT" };
        deshabilitarTipoDocumentoClone = true;
        deshabilitarFacturaClone = false;
        formularioClone.factura = "FACB";
      } else {
        deshabilitarTipoDocumentoClone = true;
        formularioClone.tipoDocumento = { sigla: "CUIT" };
        if (e.target.value === "RIN") {
          formularioClone.factura = "FACA";
          deshabilitarFacturaClone = true;
        } else {
          deshabilitarFacturaClone = false;
        }
      }
    }

    setFormulario(formularioClone);
    setDeshabilitarFactura(deshabilitarFacturaClone);
    setDeshabilitarTipoDocumento(deshabilitarTipoDocumentoClone);
  };

  const handleTipoDocumentoChange = (e) => {
    const sigla = e.target.value;
    const tipoDocumentoEncontrado = tiposDocumento.find(
      (e) => e.sigla === sigla,
    );
    let formularioClone = Object.assign({}, formulario);
    formularioClone.tipoDocumento = tipoDocumentoEncontrado;
    setFormulario(formularioClone);
  };

  const searchProvinciaFromId = (id) => {
    const provinciaEncontrado = provincias.find((e) => e.id === id);
    const provinciaEncontradoResult = provinciaEncontrado || { codigo: 0 };
    return provinciaEncontradoResult;
  };

  const handleProvinciaChange = (e) => {
    //const codigoProv = e.target.value;
    //const idProv = e.target.value;
    //const provinciaEncontrado = provincias.find((e) => e.codigo === codigoProv);
    //const provinciaEncontrado = provincias.find((e) => e.id === idProv);
    let formularioClone = Object.assign({}, formulario);
    formularioClone.localidad = { id: 0 };
    formularioClone.provincia = searchProvinciaFromId(e.target.value);
    setFormulario(formularioClone);
    //getLocalidadesPorProvincia(formularioClone.provincia.codigo);
    getPartidosPorProvincia(formularioClone.provincia.codigo, setPartidos);
  };

  const handlePartidoChange = (e) => {
      const partido = partidos.find((part) => part.id === e.target.value) || {
        codigo: "0",
        id: "0",
      };

      let formularioClone = Object.assign({}, formulario);
      formularioClone.localidad = { id: 0 };
      formularioClone.partido = partido;
      setFormulario(formularioClone);
  
      getLocalidadesPorPartido(partido.codigo, setLocalidades);
  };

  const handleLocalidadChange = (e) => {
    const idLocalidad = e.target.value;
    const localidadEncontrada = localidades.find((e) => e.id === idLocalidad);
    let formularioClone = Object.assign({}, formulario);
    formularioClone.localidad = localidadEncontrada || { id: 0 };
    setFormulario(formularioClone);
  };

  const handleMostrarDatosDeFacturacionChange = (e) => {
    setMostrarDatosDeFacturacion(e.target.value);
  };

  const handleCrearNuevoDatoDeFacturacion = () => {
    setFormularioSeleccionado(formularioDefault);
    setFormulario(formularioDefault);
  };

  const handleRepetirCamposChange = (e) => {
    handleProvinciaChange({ target: { value: idProvincia } });
    getLocalidadesPorPartido(idPartido, setLocalidades);
    //handlePartidoChange({ target: { value: idPartido } });
    handleRepetirCampos(e);
  };

  /*
  const handleMostrarListadoDeDatosDeFacturacionChange = (e) => {
    setMostrarListadoDeDatosDeFacturacion(e.target.value);
    setFormulario(formularioDefault);
  };
  */

  return (
    <div id="loader" className="loader result datos-personales">
      {pantallaOrigen !== "registrar" && (
        <div
          className="form-group d-inline-block text-left col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 bg"
          style={{ padding: "1rem" }}
        >
          <h5>Datos de Facturacion</h5>
          <input
            className="checkRegistracion"
            type="radio"
            value="true"
            name="radioMostrarDatos"
            checked={mostrarDatosDeFacturacion === "true"}
            onChange={handleMostrarDatosDeFacturacionChange}
          />{" "}
          Deseo cargar ahora los datos para mi factura
          <br />
          <input
            className="checkRegistracion"
            type="radio"
            value="false"
            name="radioMostrarDatos"
            checked={mostrarDatosDeFacturacion === "false"}
            onChange={handleMostrarDatosDeFacturacionChange}
          />{" "}
          Mas tarde cargare los datos para mi factura desde Mis Reservas
        </div>
      )}

      {mostrarDatosDeFacturacion === "true" && (
        <div>
          {pantallaOrigen !== "registrar" && (
            <div>
              <SelectorDireccionesFactura
                formularioSeleccionado={formularioSeleccionado}
                setFormulario={setFormulario}
                setFormularioSeleccionado={setFormularioSeleccionado}
                handleProvinciaChange={handleProvinciaChange}
              />

              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 row">
                <button
                  style={{ fontSize: "12px" }}
                  className="submitCargaPasajeros"
                  value="Crear Nuevo"
                  onClick={handleCrearNuevoDatoDeFacturacion}
                >
                  Agregar nueva direccion de facturacion
                </button>
              </div>
            </div>
          )}

          <div className="bg" style={{ padding: "1rem" }}>
            <h6 className="text-left">Datos para la emision de su factura</h6>
            <p className="text-left" style={{ fontSize: "0.8rem" }}>
              Todos los campos son obligatorios y recuerde ingresar los datos
              tal como quiere que figuren en la factura. No usar apodos,
              sobrenombres o abreviaturas, solo nombre y apellido completo o
              razon social, sino{" "}
              <span style={{ color: "red" }}>
                {" "}
                no tomaremos como valida la solicitud de factura.
              </span>
              <br />
              {mostrarInputsOcultos === 1 && (
                <span>
                  Los datos mostrados son los que figuran en su ficha. En caso
                  de ver errores o desear cambiar alguno, por favor contacte a
                  su vendendor.
                </span>
              )}
            </p>
            {pantallaOrigen === "registrar" && (
              <div className="form-group d-inline-block text-left col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <input
                  className="checkRegistracion"
                  type="checkbox"
                  name="check"
                  onChange={handleRepetirCamposChange}
                />
                <label
                  className="labelForm"
                  htmlFor="check"
                  style={{ fontSize: "1rem", fontWeight: "600" }}
                >
                  Repetir campos de registración
                </label>
              </div>
            )}
            <div
              id="solicitarFactura"
              className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row"
            >
              <label
                style={{ marginTop: "5px" }}
                className="labelPerfil  text-left"
                htmlFor="responsabilidad"
              >
                Categoria
              </label>
              <div className="input-group">
                <select
                  name="responsabilidad"
                  className="custom-select"
                  value={formulario.responsabilidad}
                  onChange={handelChangeFormulario}
                >
                  <option value="0">Seleccione una categoria</option>
                  <option value="RIN">Responsable Inscripto</option>
                  <option value="MON">Monotributo</option>
                  <option value="EXE">Exento</option>
                  <option value="CFI">Consumidor Final</option>
                </select>
              </div>

              <label
                style={{ marginTop: "5px" }}
                className="labelPerfil text-left"
                htmlFor="tipoDocumento"
              >
                Tipo Documento
              </label>
              <div className="input-group">
                <select
                  name="tipoDocumento"
                  className="custom-select"
                  onChange={handleTipoDocumentoChange}
                  disabled={deshabilitarTipoDocumento}
                  value={formulario.tipoDocumento.sigla}
                >
                  <option value="0">Seleccione un documento</option>
                  {tiposDocumento.map((tipoDeDocumento) => {
                    return (
                      <option
                        key={tipoDeDocumento.idTipoDocumento}
                        value={tipoDeDocumento.sigla}
                      >
                        {tipoDeDocumento.denominacion}
                      </option>
                    );
                  })}
                </select>
              </div>

              <label
                style={{ marginTop: "5px" }}
                className="labelPerfil  text-left"
                htmlFor="responsabilidad"
              >
                Responsabilidad
              </label>
              <div className="input-group">
                <select
                  name="factura"
                  className="custom-select"
                  value={formulario.factura}
                  disabled={deshabilitarFactura}
                  onChange={handelChangeFormulario}
                >
                  {formulario.responsabilidad === "CFI" ||
                  formulario.responsabilidad === "MON" ? null : (
                    <option value="FACA">Factura A</option>
                  )}
                  <option value="FACB">Factura B</option>
                </select>
              </div>

              <div
                className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                style={{ padding: "0" }}
              >
                <label
                  style={{ marginTop: "5px" }}
                  className="labelPerfil text-left"
                  htmlFor="numeroDocumento"
                >
                  {formulario.tipoDocumento.sigla !== "CUIT"
                    ? "N° Documento"
                    : "CUIT/CUIL (sin guiones)"}
                </label>
                <input
                  value={formulario.numeroDocumento}
                  name="numeroDocumento"
                  placeholder="Número"
                  type="text"
                  className="form-control"
                  onChange={handelChangeFormulario}
                />
              </div>

              <div className="form-group d-inline-block col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <label
                  style={{ marginTop: "5px" }}
                  className="labelPerfil text-left"
                  htmlFor="razonSocial"
                >
                  Nombre y Apellido Completo / Razon Social
                </label>
                <input
                  type="text"
                  value={formulario.razonSocial}
                  name="razonSocial"
                  placeholder="Nombre completo / Razon Social"
                  className="form-control"
                  onChange={handelChangeFormulario}
                />
              </div>

              <div
                className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                style={{ padding: "0" }}
              >
                <label
                  style={{ marginTop: "5px" }}
                  className="labelPerfil text-left "
                  htmlFor="calle"
                >
                  Calle
                </label>
                <input
                  value={formulario.calle}
                  name="calle"
                  placeholder="Calle"
                  type="text"
                  className="form-control"
                  onChange={handelChangeFormulario}
                />
              </div>

              <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <label
                  style={{ marginTop: "5px" }}
                  className="labelPerfil text-left "
                  htmlFor="altura"
                >
                  Altura
                </label>
                <input
                  value={formulario.altura}
                  name="altura"
                  placeholder="Numero"
                  type="text"
                  className="form-control"
                  onChange={handelChangeFormulario}
                />
              </div>

              <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <label
                  style={{ marginTop: "5px" }}
                  className="labelPerfil text-left "
                  htmlFor="codigoPostal"
                >
                  Cod. Postal
                </label>
                <input
                  value={formulario.codigoPostal}
                  name="codigoPostal"
                  placeholder="C.P."
                  type="text"
                  className="form-control"
                  onChange={handelChangeFormulario}
                />
              </div>

              <div
                className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                style={{ padding: "0" }}
              >
                <label className="labelPerfil text-left " htmlFor="provincia">
                  Provincia *
                </label>
                <select
                  className="form-control"
                  name="provincia"
                  onChange={handleProvinciaChange}
                  value={formulario.provincia.id}
                >
                  <option value="0">Provincia</option>
                  {provincias.map((provincia) => {
                    return (
                      <option key={provincia.id} value={provincia.id}>
                        {provincia.denominacion}
                      </option>
                    );
                  })}
                </select>
              </div>

               <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label className="labelForm" htmlFor="partido">
                    Partido *
                  </label>
                  <select
                    className="form-control"
                    name="partido"
                    onChange={handlePartidoChange}
                    value={formulario.partido.id}
                  >
                    <option value="0">Partido</option>
                    {partidos.map((partido) => {
                      return (
                        <option key={partido.id} value={partido.id}>
                          {partido.denominacion}
                        </option>
                      );
                    })}
                  </select>
                </div>

              <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <label className="labelPerfil text-left " htmlFor="localidades">
                  Localidad *
                </label>
                <select
                  className="form-control"
                  name="localidades"
                  onChange={handleLocalidadChange}
                  value={formulario.localidad.id}
                >
                  <option value="0">Localidad</option>
                  {localidades.map((localidad) => {
                    return (
                      <option key={localidad.id} value={localidad.id}>
                        {localidad.denominacion}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div
                className="form-group d-inline-block col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                style={{ padding: "0" }}
              >
                <label
                  style={{ marginTop: "5px" }}
                  className="labelPerfil text-left "
                  htmlFor="codigoPostal"
                >
                  Email
                </label>
                <input
                  value={formulario.mail}
                  name="mail"
                  placeholder="Email"
                  type="text"
                  className="form-control"
                  onChange={handelChangeFormulario}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DatosDeFacturacion;



// WEBPACK FOOTER //
// ./src/components/Global/DatosDeFacturacion.js